module.exports = __webpack_public_path__ + "79eafe0c30cb642f9aba3f9f0c4365d0.png";